import { http } from '@pendo/http';
import sortBy from 'lodash/sortBy';
const guideCategoryApi = '/api/s/_SID_/category/guideCategory';
import { i18n_t as $t } from '@utils/i18n';

export function fetchGuideCategories ({ items } = {}) {
    const params = items ? '?items=true' : '';

    return http.get(`${guideCategoryApi}${params}`);
}

export function fetchGuideCategory ({ categoryId, items }) {
    const params = items ? '?items=true' : '';

    return http.get(`${guideCategoryApi}/${categoryId}${params}`);
}

export async function createGuideCategory (category) {
    return http.post('/api/s/_SID_/category', category);
}

export async function updateGuideCategory (category) {
    return http.put(`/api/s/_SID_/category/${category.id}`, category);
}

export async function deleteGuideCategory (id, type, params = {}) {
    return http.delete(`/api/s/_SID_/category/${type}/${id}`, { params });
}

export async function addGuideToCategory (params) {
    const { categoryId, guideId } = params;

    const response = await http.put(`${guideCategoryApi}/${categoryId}/guide/${guideId}`, null);

    return response;
}

export async function removeGuideFromCategory (params) {
    const { categoryId, guideId } = params;

    const response = await http.delete(`${guideCategoryApi}/${categoryId}/guide/${guideId}`);

    return response;
}

export function sortByName (sortArray) {
    return sortBy(sortArray, (item) => item.name.toUpperCase());
}

export const UNASSIGNED_META_GROUP_ID = '_PENDO_UNASSIGNED_META_GROUP_';

export const DRAFT_META_GROUP_PREFIX = '_PENDO_DRAFT_META_GROUP_';

export function isDraftMetaGroup (metaGroup) {
    return metaGroup?.id?.startsWith(DRAFT_META_GROUP_PREFIX);
}

// BE doesn't support i18n, so we need to handle it on the FE
export function localizeDefaultGuideCategories (categories) {
    return categories.map((category) => {
        let localizedName = category.name;
        switch (category.name) {
            case 'Event':
                localizedName = $t('guideCategories.Event');
                break;
            case 'Intro':
                localizedName = $t('guideCategories.Intro');
                break;
            case 'Non Urgent Notification':
                localizedName = $t('guideCategories.Non Urgent Notification');
                break;
            case 'Urgent Alert':
                localizedName = $t('guideCategories.Urgent Alert');
                break;
            case 'Education':
                localizedName = $t('guideCategories.Education');
                break;
            case 'New Release':
                localizedName = $t('guideCategories.New Release');
                break;
            case 'Onboarding':
                localizedName = $t('guideCategories.Onboarding');
                break;
            case 'Design Experiment':
                localizedName = $t('guideCategories.Design Experiment');
                break;
            case 'Recruiting':
                localizedName = $t('guideCategories.Recruiting');
                break;
            case 'Poll':
                localizedName = $t('guideCategories.Poll');
                break;
            case 'NPS':
                localizedName = $t('guideCategories.NPS');
                break;
            case 'Idea Test':
                localizedName = $t('guideCategories.Idea Test');
                break;
            default:
        }

        return {
            ...category,
            name: localizedName,
        };
    });
}
